import { render, staticRenderFns } from "./WidgetUserProfileNav.vue?vue&type=template&id=a7375908&scoped=true&"
import script from "./WidgetUserProfileNav.vue?vue&type=script&lang=js&"
export * from "./WidgetUserProfileNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7375908",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7375908')) {
      api.createRecord('a7375908', component.options)
    } else {
      api.reload('a7375908', component.options)
    }
    module.hot.accept("./WidgetUserProfileNav.vue?vue&type=template&id=a7375908&scoped=true&", function () {
      api.rerender('a7375908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/userprofile/WidgetUserProfileNav.vue"
export default component.exports